module.exports = __webpack_public_path__ + "static/media/Div1Win.9b3f6035.jpg";